<div class="suggestion-message mt ml mr" >
  <p-messages severity="warn" >
    <ng-template pTemplate>
        <div class="d-flex flex-row full-width align-items-center-forced">
          <div class="col-adapt">
            <i class="ui-icon-build"></i>
          </div>
          <div class="flex-1 pl-sm">
            <p class="bold title mb-xs">{{'wip-message.title' | translate}}</p>
            <p>{{'wip-message.description' | translate}}</p>
          </div>
        </div>
    </ng-template>
  </p-messages>
</div>


